import { render, staticRenderFns } from "./mzj_Header.vue?vue&type=template&id=5ccf4503&scoped=true&"
import script from "./mzj_Header.vue?vue&type=script&lang=js&"
export * from "./mzj_Header.vue?vue&type=script&lang=js&"
import style0 from "./mzj_Header.vue?vue&type=style&index=0&id=5ccf4503&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf4503",
  null
  
)

export default component.exports